import { render, staticRenderFns } from "./ContactInformationUploadAvatarForm.vue?vue&type=template&id=5369912c&scoped=true&"
import script from "./ContactInformationUploadAvatarForm.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationUploadAvatarForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationUploadAvatarForm.vue?vue&type=style&index=0&id=5369912c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369912c",
  null
  
)

export default component.exports